import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment-timezone';
import * as _ from 'moment';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-appointment',
  templateUrl: './appointment.component.html',
  styleUrls: ['./appointment.component.scss'],
})
export class AppointmentComponent {
  appointmentForm: FormGroup;
  clients = [
    { name: 'John Doe', timezone: 'America/New_York' },
    { name: 'Jane Smith', timezone: 'Europe/London' },
  ];
  timezones = this.getFormattedTimezones(moment.tz.names()); // Get list of timezones from moment-timezone
  clientTime: any;
  dieticianTime: any;
  // filteredTZ = moment.tz.names();
  filteredTZ = this.getFormattedTimezones(moment.tz.names());
  clientData: any = {};
  constructor(private fb: FormBuilder, @Inject(MAT_DIALOG_DATA) data: any) {
    console.log(data);
    this.clientData = data;
    this.appointmentForm = this.fb.group({
      client: [data?.firstName, Validators.required],
      date: ['', Validators.required],
      time: [{ value: '', disable: true }, Validators.required],
      dieticianTimezone: [
        'Asia/Muscat (Muscat, +04, GMT+4)',
        Validators.required,
      ],
    });
  }

  ngOnInit(): void {
    this.appointmentForm.get('time')?.disable();
    this.appointmentForm.get('date')?.valueChanges.subscribe((dateValue) => {
      if (dateValue) {
        this.appointmentForm.get('time')?.enable(); // Enable the time input if date is selected
      } else {
        this.appointmentForm.get('time')?.disable(); // Disable if date is empty or not selected
      }
    });
    this.appointmentForm.get('time')?.valueChanges.subscribe((val) => {
      this.setTimes(val);
    });
  }

  getFormattedTimezones(timezones: string[]): string[] {
    return timezones.map((tz) => {
      const city = tz.split('/')[1]?.replace('_', ' ') || tz; // Extract city name
      const abbreviation = moment.tz(tz).zoneAbbr(); // Get timezone abbreviation (e.g., IST, BST)
      const offset = moment.tz(tz).utcOffset() / 60; // Get UTC offset in hours
      const offsetString = offset >= 0 ? `+${offset}` : `${offset}`; // Format offset as +X or -X
      return `${tz} (${city}, ${abbreviation}, GMT${offsetString})`; // Combine all details
    });
  }
  getClientTimezone() {
    const selectedClient = this.clients.find(
      (client) => client.name === this.appointmentForm.get('client')?.value.name
    );
    return selectedClient?.timezone || '';
  }

  getClientTime(): string {
    return this.clientTime
      ? this.clientTime +
          ' ( Client Timezone: ' +
          this.clientData.clientTimezone +
          ' )'
      : '';
  }

  onSubmit() {
    if (this.appointmentForm.valid) {
      // const { client, date, time, dieticianTimezone } =
      //   this.appointmentForm.value;
      // const clientTimezone = this.getClientTimezone();
      // const dieticianTime = moment.tz(
      //   `${_(date).format()} ${time}`,
      //   'YYYY-MM-DD HH:mm',
      //   dieticianTimezone
      // );
      // const clientTime = dieticianTime.clone().tz(clientTimezone);

      console.log(
        'Dietician Time:',
        this.dieticianTime.format('D MMM yyyy HH:mm')
      );
      console.log('Client Time:', this.clientTime.format('D MMM yyyy HH:mm'));

      // Make an API call to book the appointment
    }
  }

  setTimes(time: any) {
    const { date, dieticianTimezone } = this.appointmentForm.value;
    const clientTimezone = this.clientData.clientTimezone.split(' (')[0]; // Extract timezone from client data
    this.dieticianTime = moment.tz(
      `${_(date).format()} ${time}`,
      'YYYY-MM-DD HH:mm',
      dieticianTimezone.split(' (')[0]
    );
    this.clientTime = this.dieticianTime
      .clone()
      .tz(clientTimezone)
      .format('D MMM yyyy HH:mm');

    console.log(
      'Dietician Time:',
      this.dieticianTime.format('D MMM yyyy HH:mm')
    );
    console.log('Client Time:' + typeof this.clientTime, this.clientTime);
  }

  onFilter(e: any) {
    const val = e?.target?.value;
    setTimeout(() => {
      this.filteredTZ = this.timezones.filter((item) =>
        item.toLocaleLowerCase().includes(val.toLocaleLowerCase())
      );
      // this.filteredTZ = this.getFormattedTimezones(this.timezones);
    }, 50);
  }
}
